// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2S4y_","image":"Header_image__Ux-Nw","name":"Header_name__1ZWnR","info":"Header_info__2yyNF","infoRow":"Header_infoRow__2FcAn"};